import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";

import { Full_ROUTES } from "./shared/routes/full-layout.routes";
import { CONTENT_ROUTES } from "./shared/routes/content-layout.routes";
import { LoginPageComponent } from './pages/content-pages/login/login-page.component';

import { AuthGuard } from './shared/auth/auth-guard.service';
import { CustomrLoginComponent } from './pages/content-pages/customr-login/customr-login.component';
import { CustomerLoginResolver } from './pages/content-pages/customr-login/customer-login.resolver';
import { ShipmentStatusComponent } from './pages/content-pages/shipment-status/shipment-status.component';
import { NotFoundComponent } from './pages/content-pages/not-found/not-found.component';
import { DomainAuthGuardGuard } from './shared/auth/domain-auth-guard.guard';

const appRoutes: Routes = [
   {
    path: '',
    component: CustomrLoginComponent,
    canActivate:[DomainAuthGuardGuard],
    resolve: { companyData: CustomerLoginResolver }
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  // Legacy TrackAssured login URL, send users to the subdomain's root login page
  {
    path: 'login-trackassured',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'track/:refrenceNumber',
    component: ShipmentStatusComponent

  },
  { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'customer-login/:company',
    resolve: { companyData: CustomerLoginResolver },
    component: CustomrLoginComponent
  },
  // New generic routes
  {
    path: ':company',
    resolve: { companyData: CustomerLoginResolver },
    component: CustomrLoginComponent
  },
  {
    path: ':company/:nickname',
    resolve: { companyData: CustomerLoginResolver },
    component: CustomrLoginComponent
  },
  {
    path: '**',
    redirectTo: 'pages/error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
